import { render, staticRenderFns } from "./InsuranceStatementView.vue?vue&type=template&id=7f1dfa14&scoped=true"
import script from "./InsuranceStatementView.vue?vue&type=script&lang=ts"
export * from "./InsuranceStatementView.vue?vue&type=script&lang=ts"
import style0 from "./InsuranceStatementView.vue?vue&type=style&index=0&id=7f1dfa14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1dfa14",
  null
  
)

export default component.exports